<template>
    <div class="container">
      <h1>Remover Linhas Duplicadas</h1>
      <p class="description">
        Este utilitário remove todas as linhas duplicadas do texto que você inserir. Apenas as linhas únicas serão mantidas na saída.
      </p>
      <div class="converter-box">
        <textarea v-model="inputText" placeholder="Cole seu texto aqui, linha por linha"></textarea>
        <button @click="removeDuplicates">Remover Duplicados</button>
        <textarea ref="outputBox" v-model="outputText" readonly @click="copyToClipboard"></textarea>
        <p v-if="copied" class="copied-message">Texto copiado para a área de transferência! ✅</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "RemoveDuplicates",
    data() {
      return {
        inputText: "",
        outputText: "",
        copied: false
      };
    },
    methods: {
      removeDuplicates() {
        let lines = this.inputText.split("\n").map(line => line.trim());
        let uniqueLines = [...new Set(lines)]; // Remove duplicatas
        this.outputText = uniqueLines.join("\n");
        this.copyToClipboard();
      },
      copyToClipboard() {
        if (this.$refs.outputBox) {
          this.$refs.outputBox.select();
          document.execCommand("copy");
          this.copied = true;
          setTimeout(() => (this.copied = false), 2000);
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .description {
    font-size: 16px;
    color: #555;
    margin-bottom: 15px;
    text-align: center;
  }
  
  button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 18px;
    border-radius: 5px;
    cursor: pointer;
    transition: 0.3s;
  }
  
  button:hover {
    background-color: #0056b3;
  }
  </style>
  